import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider, Layout, App as AntApp } from 'antd';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import LiveChat from './pages/LiveChat';
import AdminPanel from './pages/AdminPanel';
import Login from './pages/Login';
import LarkCallback from './pages/LarkCallback';
import './App.css';

const { Content } = Layout;

// 极简商务风主题配置 - Minimal Business Style
const minimalTheme = {
  token: {
    // 主色调 - 商务蓝
    colorPrimary: '#1677ff',
    colorPrimaryHover: '#4096ff',
    colorPrimaryActive: '#0958d9',

    // 背景色系 - 干净白色
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f5f5f5',
    colorBgSpotlight: '#fafafa',

    // 边框色系
    colorBorder: '#d9d9d9',
    colorBorderSecondary: '#f0f0f0',

    // 文字色系
    colorText: 'rgba(0, 0, 0, 0.88)',
    colorTextSecondary: 'rgba(0, 0, 0, 0.65)',
    colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
    colorTextQuaternary: 'rgba(0, 0, 0, 0.25)',

    // 圆角
    borderRadius: 6,
    borderRadiusLG: 8,
    borderRadiusSM: 4,

    // 字体
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

    // 阴影
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
    boxShadowSecondary: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
  },
  components: {
    Layout: {
      siderBg: '#ffffff',
      bodyBg: '#f5f5f5',
      headerBg: '#ffffff',
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: '#fafafa',
      itemSelectedBg: '#e6f4ff',
      itemHoverBg: '#f5f5f5',
      itemColor: 'rgba(0, 0, 0, 0.65)',
      itemSelectedColor: '#1677ff',
    },
    Card: {
      colorBgContainer: '#ffffff',
    },
    Table: {
      colorBgContainer: '#ffffff',
      headerBg: '#fafafa',
      headerColor: 'rgba(0, 0, 0, 0.88)',
      rowHoverBg: '#fafafa',
    },
    Button: {
      primaryShadow: '0 2px 0 rgba(5, 145, 255, 0.1)',
    },
    Statistic: {
      contentFontSize: 28,
    },
  },
};

function App() {
  return (
    <AuthProvider>
      <ConfigProvider theme={minimalTheme}>
        <AntApp>
          <Router>
            <Routes>
              {/* 公开路由 */}
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<LarkCallback />} />

              {/* 独立直播间消息页 - 无侧边栏 */}
              <Route path="/live" element={
                <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
                  <Content style={{ padding: 24, overflow: 'auto' }}>
                    <LiveChat />
                  </Content>
                </Layout>
              } />

              {/* 主面板 - 所有页面合并 */}
              <Route path="/*" element={
                <ProtectedRoute><AdminPanel /></ProtectedRoute>
              } />
            </Routes>
          </Router>
        </AntApp>
      </ConfigProvider>
    </AuthProvider>
  );
}

export default App;
